export default __webpack_public_path__ + "static/3-32-0-0-6da7497cf26fcda749bd7f823610be6d.jpg";